import React from "react";
import HeadingContent from "./HeadingContent";

export default class ThankyouPage extends React.Component {
    render() {
        let { isMobile } = this.props;
        return (
            isMobile ? <div id={"thankYouContainer"} style={{ display: "none", position: "absolute", height: "100%", width: "100%", zIndex: 99, background: "white" }} >
                <div ref={this.props.getRef} style={{ textAlign: "center", paddingTop: 50, paddingLeft: 16, paddingRight: 16 }} className="flex column">
                    <div style={{ textAlign: "center" }} className="flex flex-1 column alignCenter">
                        <img width="140px" src="/images/suceessful-ic.svg" />
                        <span className="f24 c5 bold mt12 mb12">Membership Activated</span>
                        <span className="f14 c1">Thank you for choosing FITPASS.<br />
                            Enjoy working out.</span>
                        <div className="thankYouSeparator"> </div>
                        <span className="f20 c1"><span className="medium">Get the app</span>&nbsp;with just a tap!</span>
                        <div className="thankYouSeparator"> </div>
                        <span className="f16">Book workouts and begin the journey towards your fitness goals! </span>

                        <div className="flex mt20">
                            <a href="https://itunes.apple.com/in/app/fitpass/id1049745078?mt=8"> <img width={140} src="/images/app_store_ic.png" /></a>
                            <a href="https://play.google.com/store/apps/details?id=com.india.fitpass"> <img width={140} className="ml12" src="/images/play_store_ic.png" /></a>
                        </div>
                    </div>
                </div>


            </div> : <div onWheel={(e) => { e.stopPropagation(); e.preventDefault(); }} id={"thankYouContainer"} style={{ display: "none", position: "absolute", height: "100%", width: "100%", zIndex: 9999, background: "rgba(0,0,0,0.5)" }} >
                    <div id="thankYoupage" style={{ height: 0, width: 0, margin: "auto", opacity: 0, transition: " all 0.2s ease-out" }}>
                        <HeadingContent>
                            <div ref={this.props.getRef} style={{ padding: 50 }} className="flex">
                                <div style={{ textAlign: "center" }} className="flex flex-1 column alignCenter justifyCenter">
                                    <img width="180px" src="/images/suceessful-ic.svg" />
                                    <span className="f32 c5 bold mt12 mb12">Membership Activated</span>
                                    <span className="f16 c1">Thank you for choosing FITPASS.<br />
                                        Enjoy working out.</span>
                                </div>
                                <div className="flex flex-1 ml40">
                                    <img width="180px" src="/images/home_scr_with_phone@2x.png" />
                                    <div className="flex column ml20 justifyCenter">
                                        <span className="f32 c1 medium">Get the app</span>
                                        <span style={{ display: "inline-block" }} className="f20 c1 mt12 mb20">with just a tap!</span>
                                        <span className="f16">Book workouts and begin the journey towards your fitness goals! </span>
                                        <div className="flex mt20">
                                            <a href="https://itunes.apple.com/in/app/fitpass/id1049745078?mt=8"> <img width={140} src="/images/app_store_ic.png" /></a>
                                            <a href="https://play.google.com/store/apps/details?id=com.india.fitpass"><img width={140} className="ml12" src="/images/play_store_ic.png" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </HeadingContent>
                    </div>
                </div>
        )
    }
}